import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Text } from '@paygreen/paygreen-ui';

const DeleteProductText = ({ productName, children }) => (
    <>
        <Text>
            <Trans i18nKey="matching.deleteModal.deleteWarning">
                ...
                <Text htmlTag="strong">
                    {{
                        productName: productName,
                    }}
                </Text>
                ...
            </Trans>
        </Text>

        {children}
    </>
);

DeleteProductText.propTypes = {
    productName: PropTypes.string.isRequired,
};

export default withTranslation('common')(DeleteProductText);
